import { Provider } from "@angular/core";
import { BrowserPlatformAdapter } from "./browser-platform.adapter";
import { PLATFORM_ADAPTER } from "./platform.adapter";

export const platformProviders: Provider[] = [{ provide: PLATFORM_ADAPTER, useExisting: BrowserPlatformAdapter }];
